import { render, staticRenderFns } from "./control3RootWordReport.vue?vue&type=template&id=7ffa00e8&scoped=true&"
import script from "./control3RootWordReport.vue?vue&type=script&lang=js&"
export * from "./control3RootWordReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa00e8",
  null
  
)

export default component.exports